module.exports = __webpack_public_path__ + "media/images/graham-signature-5f60d36d790613195a84e71e72baf757.png";